import {Component} from '@angular/core';
@Component({
  selector: 'spinner',
  template: `<div class="spinner-border" role="status"></div>`,
})
export class SpinnerComponent {
}
